import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import CardWrapper from "../CardWrapper";
import Card from "../Card";
import { getPathogenicityColorByAllNames } from "../../../common/helpers/Constant";
import { getCnvLiterature } from "../../../state/selectors/CardsUI.selectors";

const CnvRegionBrowserCard = ({ card, cnvClassification }) => {
  return (
    <CardWrapper
      {...card}
      color={getPathogenicityColorByAllNames(cnvClassification)}
    />
  );
};

CnvRegionBrowserCard.propTypes = {
  card: PropTypes.instanceOf(Card).isRequired,
  cnvClassification: PropTypes.string,
};

CnvRegionBrowserCard.defaultProps = {
  cnvClassification: "",
};

const mapStateToProps = (state) => ({
  cnvClassification: getCnvLiterature(state),
});

export default connect(mapStateToProps)(CnvRegionBrowserCard);
